import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./EmptyState.module.css";
export const EmptyState = ({ image, heading, text, className, }) => {
    return (_jsxs("div", { className: clsx(styles.container, className), children: [_jsx("img", { src: image, alt: "", className: styles.image }), _jsx("h3", { className: styles.heading, children: heading }), _jsx("p", { className: styles.text, children: text })] }));
};
